export const environment = {
    production: false,
    URL_MAPPING: {
      PROJ_API: 'https://dev.mobilewise.vassardigital.ai/api/v1/',
      USERMGMT_API: 'https://dev.mobilewise.vassardigital.ai/api/',
      GITHUB_APIURL : 'https://api.github.com/repos/VassarlabsV3/mobilewise_flutter/dispatches',
      GITHUB_TOKEN : '',
      GOOGLE_FONTS_API_KEY: '',
      UNIAPP_ICONRUL : "https://uniapp-test.s3.us-west-2.amazonaws.com/mobilewise/mobilewise_logo.png",
      KEYSTORE_URL : "https://uniapp-test.s3.us-west-2.amazonaws.com/mobilewise/debug.keystore",
      PROXY_API: 'https://dev.mobilewise.vassardigital.ai/api/v1/apis/request',
    },
    ENV: 'dev',
    KEYCLOAK_URLS: {
        BASE_URL: 'https://dev.mobilewise.vassardigital.ai/auth',
       REDIRECT_URL: 'https://dev.mobilewise.vassardigital.ai/landing-page',
        LOGOUT_URL: 'https://dev.mobilewise.vassardigital.ai/login'
    },
   CLIENT_ID: 'mobileWebApp',
    REALM_NAME: 'mobilewise'
  };